/**
 * PRODUCT PAGE INTERACTION ENGINE
 */

class ProductPage {
  constructor() {
    this.initGallery();
    this.initVariantSelector();
    this.initStickyBuyBar();
    this.initShippingTimer();
    this.initAccordions();
  }

  initGallery() {
    const mainImg = document.querySelector('[data-main-product-image]');
    const thumbs = document.querySelectorAll('[data-gallery-thumb]');

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        thumbs.forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
        const src = thumb.getAttribute('data-full-src');
        if (mainImg && src) {
          mainImg.src = src;
        }
      });
    });
  }

  initVariantSelector() {
    const swatches = document.querySelectorAll('[data-variant-swatch]');
    const priceEl = document.querySelector('[data-product-price]');
    const variantIdInput = document.querySelector('input[name="id"]');

    swatches.forEach(swatch => {
      swatch.addEventListener('click', () => {
        const parent = swatch.closest('.variant-option-group');
        if (parent) {
          parent.querySelectorAll('[data-variant-swatch]').forEach(s => s.classList.remove('is-selected'));
        }
        swatch.classList.add('is-selected');

        const price = swatch.getAttribute('data-variant-price');
        const id = swatch.getAttribute('data-variant-id');

        if (price && priceEl) priceEl.textContent = `Rs. ${price}`;
        if (id && variantIdInput) variantIdInput.value = id;
      });
    });
  }

  initStickyBuyBar() {
    const stickyBar = document.querySelector('[data-sticky-buy-bar]');
    const mainBuyBtn = document.querySelector('[data-main-buy-btn]');

    if (!stickyBar || !mainBuyBtn) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          stickyBar.style.transform = 'translateY(0)';
        } else {
          stickyBar.style.transform = 'translateY(100%)';
        }
      });
    }, { threshold: 0.1 });

    observer.observe(mainBuyBtn);
  }

  initShippingTimer() {
    const timerEl = document.querySelector('[data-shipping-timer]');
    if (!timerEl) return;

    let secondsLeft = 4 * 3600 + 30 * 60 + 49;
    setInterval(() => {
      secondsLeft--;
      if (secondsLeft < 0) secondsLeft = 12 * 3600;
      const h = Math.floor(secondsLeft / 3600);
      const m = Math.floor((secondsLeft % 3600) / 60);
      const s = secondsLeft % 60;
      timerEl.textContent = `${h}h ${m}m ${s}s`;
    }, 1000);
  }

  initAccordions() {
    document.addEventListener('click', (e) => {
      const header = e.target.closest('[data-accordion-header]');
      if (header) {
        const item = header.closest('.accordion-item');
        if (item) {
          item.classList.toggle('is-open');
        }
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new ProductPage();
});
